import { fieldRequired } from "@ts-digital/agyo-validations";
import { translateMessage } from "../../i18n";

export const userDataForm = {
    type: "object",
    properties: {
        firstName: {
            type: "string",
            validate: fieldRequired(translateMessage("general.form.field-required"))
        },
        lastName: {
            type: "string",
            validate: fieldRequired(translateMessage("general.form.field-required"))
        }
    }
};
